@if (!is404) {
    <div class="landing-page" [class.disable-animation]="uiPreferences.disableAnimation()">
        @if (viewData?.layout?.name === 'full' || !viewData?.layout?.name) {
            @if (viewData) {
                <website-widgets-loader [widgets]="viewData.widgets"></website-widgets-loader>
            }
        } @else {
            @if (viewData) {
                @if (isSidebarBeforeEnabled) {
                    <website-widgets-loader [widgets]="widgetsSidebar.before_sidebar"></website-widgets-loader>
                }
                <div class="sidebar">
                    <div class="sidebar__layout" data-application="sidebar-layout">
                        <div
                            class="sidebar__menu"
                            id="sidebar-menu"
                            [websiteSticky]="isMobile()"
                            [stickyPositionType]="null"
                        >
                            <website-sidebar [sidebarSetting]="viewData.layout.sidebar"></website-sidebar>
                        </div>
                        <div class="sidebar__content">
                            @if (breadcrumbs && breadcrumbs.length > 0) {
                                <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
                            }

                            <article class="article">
                                @if (isSidebarEnabled) {
                                    <website-widgets-loader
                                        [widgets]="widgetsSidebar.sidebar"
                                        [layoutType]="viewData.layout.name"
                                    >
                                    </website-widgets-loader>
                                }

                                @if (showAuthorsSection) {
                                    @defer (hydrate on viewport) {
                                        <div class="authors-container">
                                            @for (author of viewData.authors; track author) {
                                                <app-author-bio [author]="author" class="sidebar-content__author-bio">
                                                </app-author-bio>
                                            }
                                        </div>
                                    } @error {}
                                }
                            </article>

                            @if (viewData.layout.sidebar.navigationItems) {
                                @defer (hydrate on viewport) {
                                    <app-paginator
                                        [navigationItems]="viewData.layout.sidebar.navigationItems"
                                    ></app-paginator>
                                } @error {}
                            }

                            @defer (on immediate) {
                                <app-sharing-buttons [seoTitle]="viewData.seoMeta?.title"></app-sharing-buttons>
                            } @error {}
                        </div>
                    </div>
                </div>

                @if (isSidebarAfterEnabled) {
                    <website-widgets-loader [widgets]="widgetsSidebar.after_sidebar"></website-widgets-loader>
                }
            }
        }

        @if (viewData?.layout?.hasScrollUpButton) {
            @defer (on idle) {
                <website-scroll-up-btn></website-scroll-up-btn>
            } @error {}
        }
    </div>
} @else {
    <tp-error></tp-error>
}
